export const MANAGE_PROCESSES_LABEL = 'Vorgänge verwalten';
export const SHOW_CLOSED_PROCESSES_LABEL =
  'Abgeschlossene/Stornierte Vorgänge anzeigen';
export const SHOW_CLOSED_PROCESSES_DESCRIPTION_LABEL =
  "Aufträge und Termine mit dem Status 'abgeschlossen' oder 'storniert' werden angezeigt";
export const SHOW_ACCOMPLISHED_PROCESSES_LABEL =
  'Durchgeführte Vorgänge anzeigen';
export const SHOW_ACCOMPLISHED_PROCESSES_DESCRIPTION_LABEL =
  "Aufträge und Termine mit dem Status 'durchgeführt' werden angezeigt";
export const MANAGE_ARTICLES_LABEL = 'Artikel verwalten';
export const SHOW_LIST_PRICES_LABEL = 'Listenpreise anzeigen';
export const SHOW_LIST_PRICES_DESCRIPTION_LABEL =
  'Bei den Artikeln werden die Listenpreise angezeigt. Bei Neuanlage von Artikeln, können Listenpreise erfasst werden.';
export const SHOW_MWST_LABEL = 'MwSt.-Satz einstellen';
export const SHOW_MWST_DESCRIPTION_LABEL =
  'Warenkörbe werden mit dem angegebenen Wert berechnet';
export const MWST_LABEL = 'MwSt';
export const SHOW_ARTICLE_IMAGES_LABEL = 'Artikelbilder anzeigen';
export const SHOW_ARTICLE_IMAGES_DESCRIPTION_LABEL =
  'Bei den Artikeln im Artikelstamm werden die Bilder angezeigt.';
export const IMPORT_ARTICLE_CATALOGS_LABEL = 'Artikelkataloge importieren';
export const IMPORT_ARTICLE_CATALOGS_DESCRIPTION_LABEL =
  'Import von Artikelkatalogen';
export const HELP_AND_SUPPORT_LABEL = 'Hilfe & Support';
export const DELETE_LOCAL_DATA_LABEL = 'Lokale Daten verwerfen';
export const DELETE_LOCAL_DATA_DESCRIPTION_LABEL =
  'Achtung: Löscht die Datenbank und lädt diese erneut aus der Cloud';
export const COMMON_HELP_LABEL = 'Allgemeine Hilfe';
export const COMMON_HELP_DESCRIPTION_LABEL = 'Hilfeseite öffnen';
export const SUPPORT_LABEL = 'Support/Feedback';
export const SUPPORT_DESCRIPTION_LABEL = 'KontaktCenter aufrufen';
export const INFORMATION_LABEL = 'Informationen';
export const VERSION_LABEL = 'Version';
export const WHAT_IS_NEW_LABEL = 'Was ist neu?';
export const VERSION_HISTORY_LABEL = 'Versionsübersicht';
export const DATA_PROTECTION_LABEL = 'Datenschutzbestimmungen';
export const DATA_PROTECTION_DESCRIPTION_LABEL =
  'Datenschutzbestimmungen einsehen';
export const TERMS_OF_USE_LABEL = 'Nutzungsbedingungen';
export const TERMS_OF_USE_DESCRIPTION_LABEL = 'Nutzungsbedingungen einsehen';
export const TEAMVIEWER_LABEL = 'TeamViewer herunterladen';
export const TEAMVIEWER_DESCRIPTION_LABEL =
  'Aktuellste TeamViewer Version herunterladen';
